import { FC } from 'react';

import { Box, useBoolean } from '@bonusly/design-system';

import { useGetLabels } from '../../components/labels/hooks/use-get-labels';
import { LabelsDisplay } from '../../components/labels/labels-display';
import { NewLabel } from '../../components/labels/new-label';

export const BookmarkEditLabels: FC = () => {
	const { data: labels } = useGetLabels();
	const [showNewLabel, { on, off }] = useBoolean(false);

	return (
		<Box>
			<LabelsDisplay
				labelsToShow={labels}
				enableAddLabelButton
				showNewLabelForm={() => {
					on();
				}}
			/>
			<NewLabel
				show={showNewLabel}
				hideNewLabelForm={() => {
					off();
				}}
			/>
		</Box>
	);
};
